import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { useNavigate, useLocation, useSearchParams as useRouterSearchParams } from 'react-router-dom';
import querystringify from 'tricks/string/querystringify';
import filterObject from 'utils/filterObject';
/*
 * TODO [react-router-dom@>=6]: Outstanding migration tasks
 * 1. Migrate call sites to react-router-dom's built-in useSearchParams hook.
 * 2. Recreate current custom semantics where needed (merge-on-update, undefined filtering,
 *    replace navigation, and pathname/hash/state preservation).
 * 3. Remove this adapter once all imports from hooks/useSearchParams are gone.
 */
export default function useSearchParams() {
  var location = useLocation();
  var navigate = useNavigate();
  var _useRouterSearchParam = useRouterSearchParams(),
    _useRouterSearchParam2 = _slicedToArray(_useRouterSearchParam, 1),
    routerSearchParams = _useRouterSearchParam2[0];
  var searchParams = Object.fromEntries(routerSearchParams.entries());
  function setSearchParams(newParams) {
    var newParamsObject;
    if (typeof newParams === 'function') {
      newParamsObject = newParams(searchParams);
    } else {
      newParamsObject = _objectSpread(_objectSpread({}, searchParams), newParams);
    }
    navigate({
      pathname: location.pathname,
      hash: location.hash,
      search: "?".concat(querystringify(filterObject(newParamsObject)))
    }, {
      replace: true,
      state: location.state
    });
  }
  return [searchParams, setSearchParams];
}